import angular from 'angular';
import { OrderItemAddOnDirectiveModule } from './addOn/addOn.directive';
import { OrderItemDonationDirectiveModule } from './donation/donation.directive';
import { OrderItemEventDirectiveModule } from './event/event.directive';
import { OrderItemMembershipDirectiveModule } from './membership/membership.directive';
import { OrderItemPriceDirectiveModule } from './price/price.directive';

function OrderItemDirective() {
  OrderItemController.$inject = ['$scope'];
  function OrderItemController($scope) {
    $scope.orderItem = {
      type: '',

      init: function () {
        this.type = this.getNormalItemType($scope.model.itemType);
      },

      getNormalItemType: function (type) {
        let result = '';

        switch (type.toLowerCase()) {
          case 'addon':
          /* falls through */
          case 'event':
          /* falls through */
          case 'donation':
            result = type;
            break;
          case 'membershiprenewal':
            result = 'membership';
            break;
        }

        return result;
      },
    };

    $scope.orderItem.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/order/item/item.tpl.html',
    scope: {
      model: '=',
      options: '@',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: OrderItemController,
  };
}

export const OrderItemDirectiveModule = angular
  .module('acme.common.directive.order.item', [
    OrderItemAddOnDirectiveModule,
    OrderItemEventDirectiveModule,
    OrderItemDonationDirectiveModule,
    OrderItemMembershipDirectiveModule,
    OrderItemPriceDirectiveModule,
  ])
  .directive('orderItem', OrderItemDirective).name;
